import i18n from '@/i18n';
import { vinReports } from '@/utils/permission';
import { PREFIX } from '@/utils/constants';
const Layout = () => import('@/layouts/main.vue');
const VinReports = () => import('./views/Index.vue');
const VinReportView = () => import('./views/VinReportView.vue');

export default [
  {
    path: 'vin-reports',
    component: Layout,
    meta: { authRequired: true, header: true },
    children: [
      {
        path: 'pending',
        name: `${PREFIX.INSPECTOR}.VinReports.Pending`,
        component: VinReports,
        meta: {
          title: i18n.global.t('vinReports.pending'),
          pageType: 'pending',
          permission: { module: vinReports.module, key: vinReports.showAll },
        },
      },
      {
        path: 'approved',
        name: `${PREFIX.INSPECTOR}.VinReports.Approved`,
        component: VinReports,
        meta: {
          title: i18n.global.t('vinReports.approved'),
          pageType: 'approved',
          permission: { module: vinReports.module, key: vinReports.showAll },
        },
      },
      {
        path: 'view/:id?',
        name: `${PREFIX.INSPECTOR}.VinReports.View`,
        component: VinReportView,
        meta: {
          title: i18n.global.t('vinReports.view'),
          pageType: 'view',
          permission: { module: vinReports.module, key: vinReports.showOne },
        },
        props: true,
      },
      {
        path: 'create',
        name: `${PREFIX.INSPECTOR}.VinReports.Create`,
        component: VinReportView,
        meta: {
          title: i18n.global.t('vinReports.create'),
          pageType: 'create',
          permission: { module: vinReports.module, key: vinReports.create },
        },
      },
      {
        path: 'update/:id?',
        name: `${PREFIX.INSPECTOR}.VinReports.Update`,
        meta: {
          title: i18n.global.t('vinReports.update'),
          pageType: 'update',
          permission: { module: vinReports.module, key: vinReports.update },
        },
        component: VinReportView,
        props: true,
      },
    ],
  },
];
